import React from 'react';

import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';

const labelClass = 'text-[11px] font-semibold text-main-normal tracking-[0.5px]';
const bannerClass = 'flex items-center gap-2 px-3 py-2.5 rounded-input border bg-[color-mix(in_srgb,var(--classicbutton-normal-color)_8%,transparent)] border-[color-mix(in_srgb,var(--classicbutton-normal-color)_30%,transparent)]';

const PpcAccessBanner = () => (
    <div>
        <span className={`block mb-2 ${labelClass}`}>PRIVACY</span>
        <div className={bannerClass}>
            <PublicOutlinedIcon className="text-classic-button-normal" style={{fontSize: 20}} />
            <div>
                <div className="text-sm font-medium text-main-normal">PPC Public Access</div>
                <div className="text-xs text-main-hover">All workspace members and guests can access this item</div>
            </div>
        </div>
    </div>
);

export default PpcAccessBanner;
